<template>
  <CModal :show.sync="show" centered add-content-classes="modal-confirm">
    <template #header-wrapper>
      <div class="d-none"></div>
    </template>
    <div>
      <div class="d-flex align-items-start">
        <CIcon name="cipTrashFull" size="custom-size"
               width="36" height="36"
               class="mr-3 icon-circle icon-circle--danger"/>
        <div class="flex-grow-1">
          <h5 class="modal-title">
            <translate translate-context="admin-payout.reject">Reject Invoice</translate>
          </h5>
          <p>
            <translate translate-context="admin-payout.reject">
              The invoice will be rejected and the photographer will need to upload a new one.
            </translate>
          </p>
          <CTextarea
            v-model="reason"
            :placeholder="$pgettext('admin-payout.reject', 'Enter the reason for rejecting this invoice...')"
            rows="3"
          />
        </div>
        <div class="flex-grow-0 mt-1 ml-4"><CButtonClose @click="close"/></div>
      </div>
    </div>
    <template #footer>
      <PButton @click="close" color="secondary" :disabled="processing">
        {{ $pgettext('admin-payout.reject', 'Cancel') }}
      </PButton>
      <PButton @click="handleReject" color="danger" :loading="processing" :disabled="!canSubmit">
        {{ $pgettext('admin-payout.reject', 'Reject Invoice') }}
      </PButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from 'vuex'
import PButton from '@/components/PButton.vue'

export default {
  name: 'RejectInvoiceModal',
  components: { PButton },
  data() {
    return {
      show: false,
      processing: false,
      payoutId: null,
      reason: ''
    }
  },
  computed: {
    canSubmit() {
      return this.reason.trim().length > 0 && !this.processing
    }
  },
  methods: {
    ...mapActions('adminPayout', ['rejectInvoice']),

    open(payoutId) {
      this.payoutId = payoutId
      this.reason = ''
      this.processing = false
      this.show = true
    },

    close() {
      this.show = false
      this.payoutId = null
      this.reason = ''
    },

    async handleReject() {
      if (!this.canSubmit) return

      this.processing = true
      try {
        await this.rejectInvoice({ id: this.payoutId, reason: this.reason.trim() })
        this.notifySuccess(this.$pgettext('admin-payout.reject', 'Invoice rejected successfully'))
        this.$emit('rejected')
        this.close()
      } catch (error) {
        this.notifyError(this.$pgettext('admin-payout.reject', 'Error rejecting invoice'))
      } finally {
        this.processing = false
      }
    }
  }
}
</script>
